// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Aydn","controls":"styles_controls__3vGli","charLimit":"styles_charLimit__SjSeM","input":"styles_input__3Xfvs","send":"styles_send__21old"};